module.exports = __webpack_public_path__ + "img/businesLicese5.91e8a415.png";